import React, { useEffect } from "react";

import { Parallax } from "react-scroll-parallax";

import { InsideParallaxImage } from "components/Image/Index";

import * as fromProjects from "store/Projects";

import { a } from "@react-spring/web";
import { useIntersect } from "hooks/useIntersect";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

interface IProps {
  animationReady: boolean;
  bodyContent: object;
  expandBodyWrapperToSectionExtents(): any;
}

export const ThreeScattered: React.FC<IProps> = ({
  animationReady,
  expandBodyWrapperToSectionExtents,
  ...props
}) => {
  const bodyContent: fromProjects.IContentImageBoardSection =
    props.bodyContent as fromProjects.IContentImageBoardSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const [animateInTrail] = useAnimateInTrail(inView, 3);

  useEffect(() => {
    expandBodyWrapperToSectionExtents();
  }, []);

  const actualItem = (item: fromProjects.IContentImageBoardContent) => {
    if (item.type === "image") {
      const image: fromProjects.IImage = item.details as fromProjects.IImage;
      return (
        <figure>
          <div className="figureWrapper">
            <InsideParallaxImage
              width="100%"
              heightRatio={item.details.heightRatio}
              src={"/assets/images/work/" + image.url}
              alt={image.alt}
              fit="contain"
              animateImageIn={true}
              animationType={"fadeIn"}
            />
          </div>
        </figure>
      );
    }
  };

  const firstImageStyles = {
    opacity: animateInTrail[0].active,
    transform: animateInTrail[0].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const secondImageStyles = {
    opacity: animateInTrail[1].active,
    transform: animateInTrail[1].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const thirdImageStyles = {
    opacity: animateInTrail[2].active,
    transform: animateInTrail[2].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  return (
    <div ref={inViewRef} className="imageBoardWrapper threeScattered">
      <Parallax y={["-10px", "30px"]} tagOuter="figure">
        <a.div className="parallaxInner" style={firstImageStyles}>
          {actualItem(bodyContent.content[0])}
        </a.div>
      </Parallax>
      <Parallax y={["-40px", "60px"]} tagOuter="figure">
        <a.div className="parallaxInner" style={secondImageStyles}>
          {actualItem(bodyContent.content[1])}
        </a.div>
      </Parallax>
      <Parallax y={["-60px", "300px"]} tagOuter="figure">
        <a.div className="parallaxInner" style={thirdImageStyles}>
          {actualItem(bodyContent.content[2])}
        </a.div>
      </Parallax>
    </div>
  );
};
